import { Layout } from 'antd';
import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router';
import { Content } from '@src/layout';
import { SidebarSkeleton } from '@src/components/ui';

// const Navbar = lazy(() => import('../layout/Navbar/Navbar'));
const TopicMenu = lazy(() => import('../layout/Sidebar/TopicMenu'));
const SideBar = lazy(() => import('../layout/Sidebar/Sidebar'));
import {
    ORDERS_URL,
    PROFILE_URL,
    CART_URL,
    SIM_MANAGEMENT_URL,
    REFERRAL_URL,
} from '@src/constants/URLS.const';
import StoreContainer from '@src/containers/StoreConainer/StoreContainer';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';
import { useMediaQuery } from 'react-responsive';
import { screenSize } from '@src/constants/ScreenSize';

const ProfilePage = lazy(() => import('../pages/profile'));
const OrdersPage = lazy(() => import('../pages/orders'));
const CartPage = lazy(() => import('../pages/cart'));
const SimManagementPage = lazy(() => import('../pages/simManagment'));
const ReferralPage = lazy(() => import('../pages/referral'));
export function DashboardRoutes() {
    const isLg = useMediaQuery({ minWidth: screenSize.lg });
    return (
        <>
            {/* <Suspense fallback={<NavbarSkeleton />}>
                <Navbar />
            </Suspense> */}

            <Layout className=" bg-lightBlue h-screen" hasSider={isLg}>
                <Suspense fallback={isLg ? <SidebarSkeleton /> : null}>
                    <SideBar menu={<TopicMenu />} />
                </Suspense>
                <Content>
                    <Routes>
                        <Route
                            path="/*"
                            element={
                                <Suspense>
                                    <StoreContainer />
                                </Suspense>
                            }
                        />
                        <Route
                            path={PROFILE_URL}
                            element={
                                <LazyLoadComponent
                                    Component={<ProfilePage />}
                                    type="FORM"
                                />
                            }
                        />
                        <Route
                            path={ORDERS_URL}
                            element={
                                <LazyLoadComponent
                                    Component={<OrdersPage />}
                                    type="LIST"
                                />
                            }
                        />
                        <Route
                            path={CART_URL}
                            element={
                                <Suspense>
                                    <CartPage />
                                </Suspense>
                            }
                        />
                        <Route
                            path={SIM_MANAGEMENT_URL}
                            element={
                                <LazyLoadComponent
                                    Component={<SimManagementPage />}
                                    type="LIST"
                                />
                            }
                        />
                        <Route
                            path={REFERRAL_URL}
                            element={
                                <LazyLoadComponent
                                    Component={<ReferralPage />}
                                    type="PAGE"
                                />
                            }
                        />
                    </Routes>
                </Content>
            </Layout>
        </>
    );
}
